<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3>
            <button class="pull-right newSelector btn btn-success addbutton agenda-add" type="button" v-on:click="createNewDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
            <i class="fa fa-fw fa-clock-o"></i> {{ _('Scheduled tasks') }}
          </h3>
        </div>
      </div>
      <Datatable :url="taskUrl" :options="tableOptions" ref="datatable" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, TaskTypeSelector } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      tableOptions: {
        rowFormatter (row) {
          const container = document.createElement('div')
          const block = document.createElement('blockquote')
          const r = row.getData()
          if (!r || !r.data) {
            return
          }
          const data = JSON.parse(r.data)
          if (r.type === 'productAction') {
            if (!data.data || !data.data.targetIds) {
              return
            }
            for (let i = 0; i < data.data.targetIds.length; i++) {
              const span = document.createElement('span')
              const id = data.data.targetIds[i]
              span.classList.add('label', 'label-default')
              span.innerHTML = '<strong>' + $this._('Product') + ':</strong> ' + id
              block.appendChild(span)
            }
          } else {
            return
          }
          container.appendChild(block)
          row.getElement().appendChild(container)
        },
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [{
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 3,
          formatter: $this.taskTypeFormatter($this.taskTypes)
        },
        {
          title: _('Action'),
          field: 'data',
          widthGrow: 3,
          formatter: $this.taskActionFormatter()
        },
        {
          title: _('Date'),
          field: 'ts',
          widthGrow: 2,
          formatter: $this.dateAndTimeFormatter(),
        },
        {
          title: _('Status'),
          field: 'status',
          widthGrow: 1,
          formatter: $this.taskStatusFormatter()
        },
        {
          title: _('Attempts'),
          field: 'tries',
          widthGrow: 1
        }],
        initialSort: [{
          column: 'ts',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.editTask(row)
        }
      }      
    }
  },
  mixins: [components, formatters],
  computed: {
    taskUrl () {
      return this.baseDomain + this.shopId + '/scheduledtasks.json?apikey=' + this.apiKey
    },
    taskTypes () {
      return [
        { 'id': '', 'name': this._('All') },
        { 'id': 'productAction', 'name': this._('Product') },
        { 'id': 'report', 'name': this._('Report') },
        { 'id': 'temperature', 'name': this._('Temperature') },
        { 'id': 'lock', 'name': this._('Lock') },
      ]
    }
  },
  methods: {
    createNewDialog () {
      this.showModal('tasktypeselector', TaskTypeSelector, {
        props: {
        },
        events: {
          selected: this.createNew
        },
        handlers: {},
        width: 800
      })
    },
    async createNew (data) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/scheduledtasks.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    async editTask (row) {
      let id = row.getCell('id').getValue()
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ScheduledTaskDetails',
        title: this._('Scheduled task') + ' ' + id,
        width: 6,
        data: {
          scheduledTaskId: id,
        }
      })
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['scheduledTaskUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }

}

</script>